import type { SxStyle } from '@aibees/shared/theme';

const MT = 1.5;
const RESERVED_HEIGHT = 1.25;

export const root: SxStyle = {
  mt: (p) => p.spacing(MT),
  minHeight: (p) => p.spacing(RESERVED_HEIGHT),
};

export const placeholder: SxStyle = {
  mt: (p) => p.spacing(MT),
  minHeight: (p) => p.spacing(RESERVED_HEIGHT),
};
